import { useState } from 'react';
import { api } from '../api';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await api.login(username, password);
      localStorage.setItem('muscuapp_token', data.token);
      localStorage.setItem('muscuapp_user', data.username);
      localStorage.setItem('muscuapp_role', data.role || 'user');
      onLogin(data.username);
    } catch (err) {
      setError(err.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-wrapper">
        <div className="login-brand">
          <div className="brand-badge brand-badge--large">🏋️</div>
          <h1 className="login-title" aria-label="MuscuApp">
            Muscu<span>App</span>
          </h1>
          <p>Suivi de performance et préparation physique</p>
        </div>

        <div className="card login-card">
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            {error && (
              <div className="alert alert-error" style={{ marginBottom: 0 }}>
                ⚠️ {error}
              </div>
            )}

            <div className="form-group">
              <label className="form-label" htmlFor="username">Identifiant</label>
              <input
                id="username"
                type="text"
                className="form-input"
                placeholder="admin"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="password">Mot de passe</label>
              <input
                id="password"
                type="password"
                className="form-input"
                placeholder="••••••••"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: '100%', justifyContent: 'center', padding: '12px', fontSize: 15 }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="spinner" style={{ width: 18, height: 18, borderWidth: 2, marginRight: 8 }} />
                  Connexion…
                </>
              ) : (
                '🔓 Se connecter'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
